export default Alpine.data('tabGroup', () => ({
    async init() {
        await this.$nextTick()
    },
    get tabs() {
        return [...this.$el.parentNode.querySelectorAll('[role="tab"]')]
    },
    get currentIndex() {
        return this.tabs.findIndex(tab => tab === document.activeElement)
    },
    selectNextTab($isSubTab = false) {
        const nextIndex = (this.currentIndex + 1) % this.tabs.length
        this.tabs[nextIndex].focus()
        this.$wire[$isSubTab ? 'goToSection' : 'setTab'](this.tabs[nextIndex].getAttribute('tabName'))
    },
    selectPreviousTab($isSubTab = false) {
        const previousIndex = (this.currentIndex - 1 + this.tabs.length) % this.tabs.length
        this.tabs[previousIndex].focus()
        this.$wire[$isSubTab ? 'goToSection' : 'setTab'](this.tabs[previousIndex].getAttribute('tabName'))
    },
}))
